import React from "react";
import { ApprovalRequestStatus } from "../../store/ApprovalCenterStore";
import "./ApprovalStatusBadge.css";

interface ApprovalStatusBadgeProps {
    status: ApprovalRequestStatus;
    className?: string;
}

const statusConfig: Record<ApprovalRequestStatus, { label: string; className: string }> = {
    [ApprovalRequestStatus.Pending]: { label: "Pending Approval", className: "pending" },
    [ApprovalRequestStatus.Approved]: { label: "Approved", className: "approved" },
    [ApprovalRequestStatus.Rejected]: { label: "Rejected", className: "rejected" }
};

export const ApprovalStatusBadge: React.FC<ApprovalStatusBadgeProps> = ({ status, className = "" }) => {
    const config = statusConfig[status];

    if (!config) {
        return null;
    }

    return (
        <div className={`approval-status-badge ${className}`} title={config.label}>
            <span className={`approval-status ${config.className}`}>{config.label}</span>
        </div>
    );
};

export const renderApprovalStatusBadge = (status: ApprovalRequestStatus, className?: string): JSX.Element => {
    return <ApprovalStatusBadge status={status} className={className} />;
};
